import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    @Inject(LOCALE_ID) public localeId: string,
  ) { }

  setToLocalStorage(object) {
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (typeof object[key] === 'object') {
          localStorage.setItem(key, JSON.stringify(object[key]));
        } else {
          localStorage.setItem(key, object[key]);
        }
      }
    }
  }

  showSnackBar(message: string, action?: string, duration?: number) {
    this.snackBar.open(message, action || null, {
      duration: duration || 1500,
      direction: 'rtl',
      horizontalPosition: this.localeId === 'fa' ? 'right' : 'left',
      panelClass: 'customSnackBar'
    });
  }

  showErrorSnackBar(message: string, action?: string, duration?: number) {
    this.snackBar.open(message, action || null, {
      duration: duration || 1500,
      direction: 'rtl',
      horizontalPosition: this.localeId === 'fa' ? 'right' : 'left',
      panelClass: 'customErrorSnackBar'
    });
  }
}
